<app-upload
  [allowedMimeTypes]="allowedMimeTypes()"
  [disabled]="disabled()"
  [dropzoneTemplateRef]="dropzoneTemplateRef"
  [maxFileSize]="maxFileSize()"
  [multi]="true"
  [uploadFn]="uploadFn" />

<ng-template
  #dropzoneTemplateRef
  let-maxFileSize="maxFileSize"
  let-pending="pending">
  <app-multimedia-choose-or-upload-dropzone
    (multimediaLibraryClickEvent)="handleMultimediaLibraryClickEvent()"
    (sendFileClickEvent)="handleSendFileClickEvent()"
    [maxFileSize]="maxFileSize" />

  @if (pending) {
    <div class="relative">
      <div class="absolute bottom-0 w-full">
        <app-progress-bar />
      </div>
    </div>
  }
</ng-template>

@if (shouldPreview()) {
  <div class="mt-4">
    <app-multimedia-grid-layout
      templateColumns="sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3">
      @for (chosenId of chosenIds(); track chosenId) {
        @if (chosenId | adminFetchMultimediaById | async; as multimedia) {
          <app-multimedia-grid-layout-item>
            <app-multimedia-tile
              [info]="false"
              [type]="multimedia.type"
              [alt]="multimedia.alt"
              [filename]="multimedia.filename"
              [size]="multimedia.size"
              [previewUrl]="multimedia.previewUrl"
              [extension]="multimedia.extension"
              (removeClickEvent)="handleRemoveClickEvent(chosenId)"
              mode="remove" />
          </app-multimedia-grid-layout-item>
        } @else {
          <app-multimedia-grid-layout-item>
            <app-multimedia-tile mode="loading" />
          </app-multimedia-grid-layout-item>
        }
      }
    </app-multimedia-grid-layout>
  </div>
}

<p-drawer
  [(visible)]="imageExplorerVisibility"
  appDrawerSidebar
  position="right"
  size="xxl">
  <ng-template #header>
    <app-drawer-title>Biblioteka mediów</app-drawer-title>
  </ng-template>

  <ng-template #content>
    @if (imageExplorerVisibility) {
      <app-multimedia-choose-multiple
        [allowedMultimediaTypes]="allowedMultimediaTypes()"
        (confirmSelectedEvent)="handleConfirmSelectedEvent($event)" />
    }
  </ng-template>
</p-drawer>
